module.exports = __webpack_public_path__ + "img/cooperation.d0681137.png";